export const ROUTE_TYPE_PUBLIC = 'public';
export const ROUTE_TYPE_PRIVATE = 'private';
export const ROUTE_TYPE_ANTI_PRIVATE = 'anti-private';
export const ROUTE_TYPE_CRUD = 'crud';
